import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';
import { CompanyContextType } from 'common/hooks/useCompanyContext/types';

import { CompanyCreationDocumentType } from '../../../../../__generated__/GQL';
import { CompanyCreationDocumentsModuleDataQuery } from '../graphql/queries/companyCreationDocumentsModuleData.gql';

export interface CompanyCreationDocumentsModuleData {
  companyContext: CompanyContextType;
  data: CompanyCreationDocumentsModuleDataQuery;
}

const initialContext = {
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => CompanyCreationDocumentsModuleData,
  selectedDocumentType: null as CompanyCreationDocumentType | null,
};

export type Context = typeof initialContext;

const model = createModel(
  initialContext,

  {
    events: {
      ...baseEvents,
      SELECT_DOCUMENT: (documentType: CompanyCreationDocumentType) => ({
        documentType,
      }),
    },
  },
);

export default model;

export type Model = typeof model;
